export default [
  {
    // Dual purpose: upfront subscribe for new tenants AND the paywall for locked-out tenants.
    // requiresAuth (not public) + on the BILLING_ALLOWLIST so locked tenants can still reach it.
    path: "/billing/checkout",
    name: "Checkout",
    component: () => import("@/views/billing/CheckoutView.vue"),
    meta: { title: "billing.checkout.title", requiresAuth: true },
  },
  {
    // Public plans & pricing page — reachable by anyone, logged in or not (no requiresAuth). It loads
    // the catalog from the unauthenticated /public/billing/catalog endpoint. On the BILLING_ALLOWLIST
    // so a logged-in but locked-out tenant can also compare plans before paying.
    path: "/plans",
    name: "Plans",
    component: () => import("@/views/billing/PlansView.vue"),
    meta: { title: "billing.plans.title" },
  },
  {
    // Standalone "change plan" page (was an in-settings dialog). Authenticated subscribers only.
    path: "/billing/change-plan",
    name: "ChangePlan",
    component: () => import("@/views/billing/ChangePlanView.vue"),
    meta: { title: "billing.settings.change_plan", requiresAuth: true },
  },
  {
    // Standalone "update payment method" page (was an in-settings dialog).
    path: "/billing/payment-method",
    name: "PaymentMethod",
    component: () => import("@/views/billing/PaymentMethodView.vue"),
    meta: { title: "billing.settings.update_card", requiresAuth: true },
  },
  {
    // Stripe Checkout return_url target (only hit for redirect-based / SCA payment methods). On the
    // billing allow-lists so a locked-out tenant returning from Stripe isn't bounced before activation.
    path: "/billing/return",
    name: "CheckoutReturn",
    component: () => import("@/views/billing/CheckoutReturnView.vue"),
    meta: { title: "billing.return.title", requiresAuth: true },
  },
  {
    // Add-on upsell for a feature-set the tenant has not purchased — where `featureSetGuard` sends a
    // blocked navigation, and the one page in the app that is *about* a feature you cannot open.
    // Deliberately NOT on the BILLING_ALLOWLIST: a tenant without an active subscription belongs on the
    // paywall, not in front of an add-on.
    path: "/billing/locked/:featureSet",
    name: "FeatureLocked",
    props: true,
    component: () => import("@/views/billing/FeatureLockedView.vue"),
    meta: { title: "billing.locked.eyebrow", requiresAuth: true },
  },
]
